module.exports = __webpack_public_path__ + "static/media/alarm-exclamation.7137e61e.svg";